import { useState } from 'react';

import { toast } from 'sonner';

import { Permission } from '../../../../../../backend/src/auth/permissions/permission';
import { useUpdateRequireMatterCode } from '@/api/mutations/useUpdateRequireMatterCode';
import { useUserContext } from '@/Contexts/User';
import { PermissionGate } from '@/hooks/useHasPermission';
import { SettingsContent, SettingsRow, SettingsSection } from '@/new/components/settings-section';
import { Switch } from '@/new/components/shadcn/switch';

export function General() {
  const { user } = useUserContext();

  const updateRequireMatterCode = useUpdateRequireMatterCode();

  // Optimistic local state so the switch reflects the toggle immediately.
  const [requireMatterCode, setRequireMatterCode] = useState(user?.organisation?.requireMatterCode ?? false);

  const handleToggle = async (checked: boolean) => {
    setRequireMatterCode(checked);
    try {
      await updateRequireMatterCode.mutateAsync({ requireMatterCode: checked });
      toast.success(`Matter codes are now ${checked ? 'required' : 'optional'} for new matters`);
    } catch {
      setRequireMatterCode(!checked);
      toast.error('Failed to update matter code setting');
    }
  };

  return (
    <SettingsContent>
      <SettingsSection title="General" description="Configure general settings for your organisation.">
        <PermissionGate permission={Permission.UserManage} uiMode="disabled">
          <SettingsRow
            title="Require Matter code"
            description="When enabled, a Matter code must be provided when creating a new Matter."
          >
            <Switch
              id="require-matter-code"
              checked={requireMatterCode}
              onCheckedChange={handleToggle}
              disabled={updateRequireMatterCode.isLoading}
            />
          </SettingsRow>
        </PermissionGate>
      </SettingsSection>
    </SettingsContent>
  );
}
